export enum SpanDirection {
  SHORTEST_SPAN = "SHORTEST_SPAN",
  LONGEST_SPAN = "LONGEST_SPAN",
  SPECIFY = "SPECIFY",
}

export enum StructuralFloorType {
  FRAMING = "FRAMING", //subdivide this further into blocked, unblocked
  SLAB = "SLAB",
}

export enum JoistPlacement {
  RIM = "RIM",
  FLOOR = "FLOOR",
  NOGGIN = "NOGGIN",
}

export enum RimBoardAlignment {
  INTERIOR = "INTERIOR",
  CENTER = "CENTER",
  EXTERIOR = "EXTERIOR",
}
